import React from 'react'
import { Configure, Index } from 'react-instantsearch-dom'
import ScrollInfiniteHits from './AlgoliaCustoms/InfiniteHits/ScrollInfiniteHits'
import HitsCounter from './Recipes/HitsCounter'
import FullImageRecipeCard from './Recipes/Cards/FullImageRecipeCard'

const Results = ({
  indexName, resultState, firstsDailyRecipes, localFiles
}) => (
  <Index indexName={indexName}>
    <Configure
      filters="language:fr"
      hitsPerPage={20}
    />
    <HitsCounter resultState={resultState} firstsDailyRecipes={firstsDailyRecipes} />
    <ScrollInfiniteHits
      HitComponent={FullImageRecipeCard}
      resultState={resultState}
      firstsDailyRecipes={firstsDailyRecipes}
      localFiles={localFiles}
    />
  </Index>
)

export default Results
